import React from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaEnvelope, FaLock, FaCalendar, FaImage, FaVenusMars, FaEye, FaEyeSlash } from 'react-icons/fa';
import Modal from 'react-modal';
import env from "react-dotenv";

const URL = `${env.API_URL}/register`;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '12px',
    padding: '30px',
    maxWidth: '400px',
    width: '90%'
  }
};

Modal.setAppElement('#root');

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      email: '',
      password: '',
      confirmPassword: '',
      first_name: '',
      last_name: '',
      birth_date: '',
      profile_image: null,
      gender: 'other',
      serverResponse: '',
      isLoading: false,
      showPassword: false,
      showConfirmPassword: false,
      errors: {
        email: '',
        password: '',
        confirmPassword: '',
        first_name: '',
        last_name: '',
        birth_date: ''
      }
    };
  }

  // Input validation
  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  validatePassword = (password) => {
    // At least 8 characters, 1 uppercase, 1 lowercase, 1 number
    return password.length >= 8 && 
           /[A-Z]/.test(password) && 
           /[a-z]/.test(password) && 
           /[0-9]/.test(password);
  }

  validateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    const age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      return age - 1 >= 13;
    }
    return age >= 13;
  }

  onFirstNameChange = (event) => {
    const value = event.target.value;
    this.setState({
      first_name: value,
      errors: { ...this.state.errors, first_name: value.trim() ? '' : 'First name is required' }
    });
  }

  onLastNameChange = (event) => {
    const value = event.target.value;
    this.setState({
      last_name: value,
      errors: { ...this.state.errors, last_name: value.trim() ? '' : 'Last name is required' }
    });
  }

  onEmailChange = (event) => {
    const value = event.target.value;
    this.setState({
      email: value,
      errors: { 
        ...this.state.errors, 
        email: this.validateEmail(value) ? '' : 'Please enter a valid email address' 
      }
    });
  }

  onPasswordChange = (event) => {
    const value = event.target.value;
    this.setState({
      password: value,
      errors: { 
        ...this.state.errors, 
        password: this.validatePassword(value) 
          ? '' 
          : 'Password must be at least 8 characters with uppercase, lowercase, and number' 
      }
    });
  }

  onConfirmPasswordChange = (event) => {
    const value = event.target.value;
    this.setState({
      confirmPassword: value,
      errors: { 
        ...this.state.errors, 
        confirmPassword: value === this.state.password ? '' : 'Passwords do not match' 
      }
    });
  }

  ondateofbirthChange = (event) => {
    const value = event.target.value;
    this.setState({
      birth_date: value,
      errors: { 
        ...this.state.errors, 
        birth_date: this.validateAge(value) ? '' : 'You must be at least 13 years old to register' 
      }
    });
  }

  onprofileImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size must be less than 5MB');
        return;
      }
      // Check file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      this.setState({ profile_image: file });
    }
  }

  onGenderChange = (event) => {
    this.setState({ gender: event.target.value });
  }

  validateForm = () => {
    const { email, password, confirmPassword, first_name, last_name, birth_date, profile_image } = this.state;
    
    if (!first_name.trim()) {
      alert('Please enter your first name');
      return false;
    }
    if (!last_name.trim()) {
      alert('Please enter your last name');
      return false;
    }
    if (!this.validateEmail(email)) {
      alert('Please enter a valid email address');
      return false;
    }
    if (!this.validatePassword(password)) {
      alert('Password must be at least 8 characters with uppercase, lowercase, and number');
      return false;
    }
    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return false;
    }
    if (!birth_date) {
      alert('Please enter your date of birth');
      return false;
    }
    if (!this.validateAge(birth_date)) {
      alert('You must be at least 13 years old to register');
      return false;
    }
    if (!profile_image) {
      alert('Please upload a profile image');
      return false;
    }
    
    return true;
  }

  onSubmitSignIn = async () => {
    if (!this.validateForm()) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      let formData = new FormData();
      formData.append('email', this.state.email.toLowerCase().trim());
      formData.append('password', this.state.password);
      formData.append('first_name', this.state.first_name.trim());
      formData.append('last_name', this.state.last_name.trim());
      formData.append('birth_date', this.state.birth_date);
      formData.append('profile_image', this.state.profile_image);
      formData.append('gender', this.state.gender);

      const response = await fetch(URL, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (response.ok && data) {
        this.setState({
          serverResponse: "Account created successfully! Please sign in now.",
          modalIsOpen: true,
          isLoading: false
        });
      } else {
        this.setState({
          serverResponse: data.error || "Failed to create account. Please try again.",
          modalIsOpen: true,
          isLoading: false
        });
      }
    } catch (error) {
      console.error('Registration error:', error);
      this.setState({
        serverResponse: "An error occurred. Please try again.",
        modalIsOpen: true,
        isLoading: false
      });
    }
  }

  closeModalAndRedirect = () => {
    this.setState({ modalIsOpen: false });
    if (this.state.serverResponse.includes('successfully')) {
      // Redirect to signin page
      if (this.props.history) {
        this.props.history.push('/signin');
      } else {
        window.location.href = '/signin';
      }
    }
  }

  render() {
    const { errors, isLoading, showPassword, showConfirmPassword } = this.state;

    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <article style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
          maxWidth: '500px',
          width: '100%',
          padding: '40px'
        }}>
          <main>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <img 
                src="/images/p10.jpg" 
                alt="P10" 
                style={{ 
                  height: '64px', 
                  width: '64px', 
                  borderRadius: '12px',
                  marginBottom: '20px'
                }} 
              />
              <h1 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                color: '#1f2937',
                margin: '0 0 10px 0'
              }}>
                Sign Up to p10
              </h1>
              <p style={{ color: '#6b7280', margin: 0 }}>Create your account to get started</p>
            </div>

            <div style={{ display: 'grid', gap: '20px' }}>
              {/* First Name */}
              <div>
                <label style={labelStyle}>
                  <FaUser style={{ marginRight: '8px' }} />
                  First Name
                </label>
                <input
                  style={{...inputStyle, borderColor: errors.first_name ? '#ef4444' : '#e5e7eb'}}
                  type="text"
                  name="first_name"
                  id="first_name"
                  placeholder="Enter your first name"
                  onChange={this.onFirstNameChange}
                />
                {errors.first_name && <p style={errorStyle}>{errors.first_name}</p>}
              </div>

              {/* Last Name */}
              <div>
                <label style={labelStyle}>
                  <FaUser style={{ marginRight: '8px' }} />
                  Last Name
                </label>
                <input
                  style={{...inputStyle, borderColor: errors.last_name ? '#ef4444' : '#e5e7eb'}}
                  type="text"
                  name="last_name"
                  id="last_name"
                  placeholder="Enter your last name"
                  onChange={this.onLastNameChange}
                />
                {errors.last_name && <p style={errorStyle}>{errors.last_name}</p>}
              </div>

              {/* Email */}
              <div>
                <label style={labelStyle}>
                  <FaEnvelope style={{ marginRight: '8px' }} />
                  Email
                </label>
                <input
                  style={{...inputStyle, borderColor: errors.email ? '#ef4444' : '#e5e7eb'}}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter your email"
                  onChange={this.onEmailChange}
                />
                {errors.email && <p style={errorStyle}>{errors.email}</p>}
              </div>

              {/* Password */}
              <div>
                <label style={labelStyle}>
                  <FaLock style={{ marginRight: '8px' }} />
                  Password
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    style={{...inputStyle, borderColor: errors.password ? '#ef4444' : '#e5e7eb', paddingRight: '40px'}}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="Create a password"
                    onChange={this.onPasswordChange}
                  />
                  <button
                    type="button"
                    onClick={() => this.setState({ showPassword: !showPassword })}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {errors.password && <p style={errorStyle}>{errors.password}</p>}
              </div>

              {/* Confirm Password */}
              <div>
                <label style={labelStyle}>
                  <FaLock style={{ marginRight: '8px' }} />
                  Confirm Password
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    style={{...inputStyle, borderColor: errors.confirmPassword ? '#ef4444' : '#e5e7eb', paddingRight: '40px'}}
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    id="confirmPassword"
                    placeholder="Confirm your password"
                    onChange={this.onConfirmPasswordChange}
                  />
                  <button
                    type="button"
                    onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                {errors.confirmPassword && <p style={errorStyle}>{errors.confirmPassword}</p>}
              </div>

              {/* Date of Birth */}
              <div>
                <label style={labelStyle}>
                  <FaCalendar style={{ marginRight: '8px' }} />
                  Date of Birth
                </label>
                <input
                  style={{...inputStyle, borderColor: errors.birth_date ? '#ef4444' : '#e5e7eb'}}
                  type="date"
                  name="birth_date"
                  id="birth_date"
                  onChange={this.ondateofbirthChange}
                />
                {errors.birth_date && <p style={errorStyle}>{errors.birth_date}</p>}
              </div>

              {/* Gender */}
              <div>
                <label style={labelStyle}>
                  <FaVenusMars style={{ marginRight: '8px' }} />
                  Gender
                </label>
                <select 
                  style={inputStyle}
                  value={this.state.gender} 
                  onChange={this.onGenderChange}
                >
                  <option value="other">Prefer not to say</option>
                  <option value="female">Female</option>
                  <option value="male">Male</option>
                </select>
              </div>

              {/* Profile Image */}
              <div>
                <label style={labelStyle}>
                  <FaImage style={{ marginRight: '8px' }} />
                  Profile Image <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <input
                  style={inputStyle}
                  type="file"
                  name="profile_image"
                  id="profile_image"
                  accept="image/*"
                  onChange={this.onprofileImageChange}
                  required
                />
                <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '5px' }}>
                  Required. Max size: 5MB. Supported formats: JPG, PNG, GIF
                </p>
              </div>

              {/* Submit Button */}
              <button
                onClick={this.onSubmitSignIn}
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '14px',
                  backgroundColor: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.6 : 1,
                  marginTop: '10px'
                }}
              >
                {isLoading ? 'Creating Account...' : 'Sign Up'}
              </button>

              {/* Sign In Link */}
              <div style={{ textAlign: 'center', marginTop: '10px' }}>
                <p style={{ color: '#6b7280', margin: 0 }}>
                  Already have an account?{' '}
                  <Link 
                    to="/signin"
                    style={{ color: '#3b82f6', fontWeight: '600', textDecoration: 'none' }}
                  >
                    Log in
                  </Link>
                </p>
              </div>
            </div>
          </main>

          {/* Success/Error Modal */}
          <Modal 
            style={customStyles} 
            isOpen={this.state.modalIsOpen} 
            onRequestClose={this.closeModalAndRedirect}
          >
            <div style={{ textAlign: 'center' }}>
              <h2 style={{ 
                fontSize: '1.5rem', 
                fontWeight: '700', 
                color: '#1f2937',
                marginBottom: '15px'
              }}>
                {this.state.serverResponse.includes('successfully') ? '✅ Success!' : '⚠️ Notice'}
              </h2>
              <p style={{ 
                fontSize: '16px', 
                color: '#6b7280',
                marginBottom: '25px' 
              }}>
                {this.state.serverResponse}
              </p>
              <button 
                onClick={this.closeModalAndRedirect}
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '700',
                  cursor: 'pointer'
                }}
              >
                {this.state.serverResponse.includes('successfully') ? 'Go to Sign In' : 'Close'}
              </button>
            </div>
          </Modal>
        </article>
      </div>
    );
  }
}

const labelStyle = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: '600',
  fontSize: '14px',
  color: '#374151',
  marginBottom: '8px'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  fontSize: '14px',
  outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box'
};

const errorStyle = {
  color: '#ef4444',
  fontSize: '12px',
  marginTop: '5px',
  marginBottom: 0
};

export default Register;